export const DESTINATION_LOGOS: Record<number, string> = {
  1:   'meta.svg',
  4:   'pubmatic.svg',
  5:   'adform.svg',
  7:   'google-ad-manager.svg',
  9:   'pubmatic.svg',
  16:  'tncid.svg',
  17:  'sftp.svg',
  26:  'the-trade-desk.svg',
  32:  'google-display-and-video-ads.svg',
  33:  'connected-tv.svg',
  101: 'the-trade-desk.svg',
  102: 'amazon-dsp.svg',
  103: 'infosum.svg',
  104: 'google-cloud-storage.svg',
  105: 'amazon-s3.svg',
  106: 'azure-storage-blob.svg',
};

export function getDestinationLogoPath(typeId: number): string | null {
  const file = DESTINATION_LOGOS[typeId];
  return file ? `assets/destination-logos/${file}` : null;
}
